import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIPhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "2 2 20 20",
	strokeWidth: 1.5,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.2502 19.25H8.75C7.64543 19.25 6.75 18.3546 6.75 17.25V6.75C6.75 5.64543 7.64543 4.75 8.75 4.75H15.2502C16.3548 4.75 17.2502 5.64543 17.2502 6.75V17.25C17.2502 18.3546 16.3548 19.25 15.2502 19.25Z",
		stroke: "currentColor",
		strokeWidth: "inherit",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.75 16.75H12.25",
		stroke: "currentColor",
		strokeWidth: "inherit",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgIPhone;
